import { render, staticRenderFns } from "./horarioSillon.vue?vue&type=template&id=0b1beb38&scoped=true"
import script from "./horarioSillon.vue?vue&type=script&lang=js"
export * from "./horarioSillon.vue?vue&type=script&lang=js"
import style0 from "./horarioSillon.vue?vue&type=style&index=0&id=0b1beb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1beb38",
  null
  
)

export default component.exports